import React from 'react';
export function useWindowSize() {
  const [size, setSize] = React.useState({
    width: 0,
    height: 0,
  });

  React.useLayoutEffect(() => {
    const handleResize = () => {
      // On Safari, pinch-zoom change affects `innerWidth/Height`. It is effectively the visible viewport width.
      // Thus avoid `innerWidth/Height`. By contrast `clientWidth/Height` stays constant to the unzoomed size.
      setSize({
        width: document.documentElement.clientWidth ?? 0,
        height: document.documentElement.clientHeight ?? 0,
      });
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return size;
}
